/* eslint-disable */

Array.prototype.find ||
  Object.defineProperty(Array.prototype, "find", {
    value: function (t) {
      if (null == this) throw new TypeError('"this" is null or not defined');
      var r = Object(this),
        e = r.length >>> 0;
      if ("function" != typeof t)
        throw new TypeError("predicate must be a function");
      for (var n = arguments[1], o = 0; o < e; ) {
        var i = r[o];
        if (t.call(n, i, o, r)) return i;
        o++;
      }
    },
  }),
  Array.prototype.findIndex ||
    Object.defineProperty(Array.prototype, "findIndex", {
      value: function (t) {
        if (null == this) throw new TypeError('"this" is null or not defined');
        var r = Object(this),
          e = r.length >>> 0;
        if ("function" != typeof t)
          throw new TypeError("predicate must be a function");
        for (var n = arguments[1], o = 0; o < e; ) {
          var i = r[o];
          if (t.call(n, i, o, r)) return o;
          o++;
        }
        return -1;
      },
    }),
  Array.from ||
    (Array.from = (function () {
      function c(t) {
        return "function" == typeof t || "[object Function]" === r.call(t);
      }
      function p(t) {
        var r = (function (t) {
          var r = Number(t);
          return isNaN(r)
            ? 0
            : 0 !== r && isFinite(r)
              ? (0 < r ? 1 : -1) * Math.floor(Math.abs(r))
              : r;
        })(t);
        return Math.min(Math.max(r, 0), e);
      }
      var r = Object.prototype.toString,
        e = Math.pow(2, 53) - 1;
      return function (t, r, e) {
        var n = Object(t);
        if (null == t)
          throw new TypeError(
            "Array.from requires an array-like object - not null or undefined"
          );
        var o,
          i = 1 < arguments.length ? r : void 0;
        if (void 0 !== i) {
          if (!c(i))
            throw new TypeError(
              "Array.from: when provided, the second argument must be a function"
            );
          2 < arguments.length && (o = e);
        }
        for (
          var a,
            u = p(n.length),
            f = c(this) ? Object(new this(u)) : new Array(u),
            l = 0;
          l < u;

        )
          (a = n[l]),
            (f[l] = i ? (void 0 === o ? i(a, l) : i.call(o, a, l)) : a),
            (l += 1);
        return (f.length = u), f;
      };
    })()),
  Array.prototype.includes ||
    Object.defineProperty(Array.prototype, "includes", {
      value: function (t, r) {
        if (null == this) throw new TypeError('"this" is null or not defined');
        var e = Object(this),
          n = e.length >>> 0;
        if (0 == n) return !1;
        var o,
          i,
          a = 0 | r,
          u = Math.max(0 <= a ? a : n - Math.abs(a), 0);
        for (; u < n; ) {
          if (
            (o = e[u]) === (i = t) ||
            ("number" == typeof o &&
              "number" == typeof i &&
              isNaN(o) &&
              isNaN(i))
          )
            return !0;
          u++;
        }
        return !1;
      },
    }),
  (function () {
    if ("function" == typeof window.CustomEvent) return;
    function t(t, r) {
      r = r || { bubbles: !1, cancelable: !1, detail: void 0 };
      var e = document.createEvent("CustomEvent");
      return e.initCustomEvent(t, r.bubbles, r.cancelable, r.detail), e;
    }
    (t.prototype = window.Event.prototype), (window.CustomEvent = t);
  })(),
  Math.log10 ||
    (Math.log10 = function (t) {
      return Math.log(t) * Math.LOG10E;
    }),
  Math.sign ||
    (Math.sign = function (t) {
      return (0 < t) - (t < 0) || +t;
    }),
  "function" != typeof Object.assign &&
    Object.defineProperty(Object, "assign", {
      value: function (t, r) {
        "use strict";
        if (null == t)
          throw new TypeError("Cannot convert undefined or null to object");
        for (var e = Object(t), n = 1; n < arguments.length; n++) {
          var o = arguments[n];
          if (null != o)
            for (var i in o)
              Object.prototype.hasOwnProperty.call(o, i) && (e[i] = o[i]);
        }
        return e;
      },
      writable: !0,
      configurable: !0,
    });
